<app-i18n-dictionary>
    <span [attr.transid]="deleteQuoteMessageTextId" i18n="@@quote-detail_delete-quote-confirmation-message">Do you
        really want to delete this quote?
    </span>
    <span [attr.transid]="deleteQuoteProductMessageTextId"
        i18n="@@quote-detail_delete-quote-product-confirmation-message">Do you really want to delete this product from
        the quote?
    </span>
</app-i18n-dictionary>

<div class="loading-spinner" *ngIf="isPending">
    <div class="background"></div>
    <mat-spinner [diameter]="70"></mat-spinner>
</div>

<div class="menu-container" *ngIf="!(requestQuote$ | async) && !(editQuote$ | async)">
    <div class="menu-header">
        <div class="back-arrow">
            <button class="dotted-arrow" mat-icon-button (click)="onDeselectQuote()">←</button>
        </div>
        <h3 class="quote-name">{{quoteName}}</h3>
    </div>

    <div class="meta-btn-wrapper" *ngIf="quoteBarItem.quote.state === 'NEW'" >
        <button class="btn-primary main-btn" [disabled]="isPending" (click)="editQuote()" i18n="@@quote-detail_edit-button">Edit</button>
        <button (click)="openDeleteConfirmationDialog($event)" [disabled]="isPending"
                class="btn-primary main-btn" i18n="@@quote-detail_delete-button">Delete
        </button>
    </div>

    <div  class="quote-created-on" [ngClass]="{'border-top': quoteBarItem.quote.state !== 'NEW'}">
        <div>
            <span i18n="@@quote-detail_created-on">Created on: </span> {{quoteBarItem.quote.creationDate | date}}
        </div>
        <div class="download-as-pdf">
            <a i18n="@@quote-detail_download-quote-message" (click)="onDownloadQuote()">Download as PDF</a>
        </div>
    </div>

    <div class="quote-products-container">
        <div *ngFor="let quoteItem of quoteBarItem.quote.quoteItems; let indx = index" [attr.data-index]="indx"
             class="quote-product"
             [ngClass]="{'last-product' : quoteBarItem.quote.quoteItems.length >= 3 && indx === quoteBarItem.quote.quoteItems.length - 1}">
            <div class="quote-product-img">
                <img src="{{thumbnail(quoteItem.productId)}}">
            </div>
            <div class="quote-product-details">
                <div class="quote-product-info">
                    <div class="product-header">
                        <div class="product-quote-name mat-body-strong">{{productDictionary[quoteItem.productId].decor.label}}</div>
                        <mat-icon class="delete-product-icon" *ngIf="quoteBarItem.quote.state === 'NEW'"
                                  (click)="openDeleteProductConfirmationDialog(productDictionary[quoteItem.productId])">
                            clear
                        </mat-icon>
                    </div>
                    <div class="product-name">{{productDictionary[quoteItem.productId].name}}</div>
                    <div class="product-sku">{{productDictionary[quoteItem.productId].sku}}</div>
                </div>

                <form [formGroup]="quantityForms[quoteItem.productId]" class="quote-product-quantity">
                    <div class="quote-product-quantity">
                        <div class="active-quote" *ngIf="quoteBarItem.quote.state === 'NEW'">
                            <a (click)="reduceQuantity(quoteItem)">-</a>
                            <input readonly type="text" [value]="quoteItem.quantity" formControlName="quantity">
                            <a (click)="increaseQuantity(quoteItem)">+</a>
                        </div>

                        <div class="requested-quote" *ngIf="quoteBarItem.quote.state !== 'NEW'">
                            {{quoteItem.quantity}}
                        </div>
                    </div>
                </form>

                <div class="quote-product-total-price">
                    {{((quoteItem.quantity) * (productDictionary[quoteItem.productId].price)) | currency : this.storeService.getStoreCurrency()}}
                </div>
            </div>
        </div>
    </div>

    <div i18n="@@quote-detail_no-products" *ngIf="quote.quoteItems.length == 0" class="no-products">
        No products
    </div>

    <div class="menu-footer">
        <div class="total-price mat-body-strong">
            <div>Total:</div>
            <div>{{getTotalPrice() | currency : this.storeService.getStoreCurrency()}}</div>
        </div>
        <div *ngIf="quote.state === 'NEW' || quote.quoteItems.length > 1" class="quote-action-buttons">
            <button class="btn-primary main-btn order-btn" [disabled]="isPending"
                (click)="openRequestQuote(quote, true)" i18n="@@quote-detail_order">Order</button>
            <button class="btn-primary main-btn request-btn" [disabled]="isPending"
                (click)="openRequestQuote(quote, false)" i18n="@@quote-detail_request">Request
            </button>

            <mat-icon class="info-icon" [matTooltip]="tooltipMessage">info</mat-icon>
        </div>
    </div>
</div>

<request-quote *ngIf="(requestQuote$ | async) && !(editQuote$ | async)" [user]="userData$ | async" [quote]="quote"
    [isOrder]="isOrder" [countries]="countries$ | async" [countriesIsPending]="countriesIsPending$ | async">
</request-quote>

<edit-quote *ngIf="(editQuote$ | async) && !(requestQuote$ | async)" [selectedQuote]="quote"></edit-quote>
